import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { BookingsTab } from "@/components/admin/BookingsTab";
import { ScheduleTab } from "@/components/admin/ScheduleTab";
import { PackagesTab } from "@/components/admin/PackagesTab";
import { AddonsTab } from "@/components/admin/AddonsTab";
import { SettingsTab } from "@/components/admin/SettingsTab";

const TABS = [
  ["bookings", "Rezerwacje", BookingsTab],
  ["schedule", "Terminy", ScheduleTab],
  ["packages", "Pakiety i ceny", PackagesTab],
  ["addons", "Opcje dodatkowe", AddonsTab],
  ["settings", "Ustawienia", SettingsTab],
];

export default function AdminPage() {
  const [user, setUser] = useState(null);
  useEffect(() => { api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false)); }, []);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("dd_admin_token");
    setUser(false);
  };

  if (user === null) return <div className="min-h-screen grid place-items-center text-muted-foreground">Ładowanie...</div>;
  if (!user) return <AdminLogin onLogin={setUser} />;

  return (
    <div data-testid="admin-panel" className="min-h-screen">
      <header className="border-b border-white/10 bg-black/60 backdrop-blur sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-between gap-4">
          <div className="flex items-center gap-4"><Logo className="h-12 sm:h-14" to="/admin" /><span className="eyebrow text-primary hidden sm:inline">Panel admina</span></div>
          <div className="flex items-center gap-2">
            <Link to="/" data-testid="admin-view-site" className="p-2 text-white/60 hover:text-primary"><ExternalLink size={18} /></Link>
            <button data-testid="admin-logout-button" onClick={logout} className="flex items-center gap-2 text-sm px-3 py-2 rounded-md border border-white/15 hover:border-primary transition-colors"><LogOut size={16} /> Wyloguj</button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-5 sm:px-8 py-8">
        <Tabs defaultValue={new URLSearchParams(window.location.search).get("google") ? "settings" : "bookings"}>
          <TabsList className="bg-card border border-white/10 h-auto w-full sm:w-auto justify-start overflow-x-auto [scrollbar-width:none]">
            {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`} className="shrink-0 data-[state=active]:bg-primary data-[state=active]:text-black">{l}</TabsTrigger>)}
          </TabsList>
          {TABS.map(([v, , C]) => <TabsContent key={v} value={v} className="mt-8"><C /></TabsContent>)}
        </Tabs>
      </main>
    </div>
  );
}
